const convertBRLCurrencyToNumber = (value: string) =>
	parseFloat(value.replaceAll('.', '').replace(',', '.')) || 0;

export {convertBRLCurrencyToNumber};
